import React from 'react';
import PropTypes from 'prop-types';

const Description = ({
  cancelled, routeNameDisplay, platformDisplay, headSignDisplay,
}) => (
  <div className="movement-info-description-container" aria-hidden="true">
    <div className="movement-info-description">
      <span className="movement-info-route-short-name">{routeNameDisplay}</span>
      {!cancelled && platformDisplay
        && (
          <span className="movement-info-platform">
            {platformDisplay}
          </span>
        )}
    </div>
    { headSignDisplay && (
      <span className="movement-info-description-destination">
        {headSignDisplay}
      </span>
    ) }
  </div>
);
Description.propTypes = {
  cancelled: PropTypes.bool.isRequired,
  routeNameDisplay: PropTypes.string.isRequired,
  platformDisplay: PropTypes.string,
  headSignDisplay: PropTypes.string,
};
Description.defaultProps = {
  headSignDisplay: null,
  platformDisplay: null,
};

export default Description;